











import { defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'

export default defineComponent({
    name: 'CreateLeadButton',
    setup() {
        const { open } = useCreateLeadForm()

        return {
            open,
        }
    },
})
